import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setDate({ commit }, data) {
    commit(types.SET_DATE, data)
  },
  setView({ commit }, data) {
    commit(types.SET_VIEW, data)
  },
  setTechData({ commit }, data) {
    commit(types.SET_TECHDATA, data)
  },
  setData({ commit }, data) {
    commit(types.SET_DATA, data)
  },
  async getDashboard({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboard', () =>
      http.get('dashboard/dashboard', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD, r.data)
    return r.data
  },
  async getDashboardBreakout({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardBreakout', () =>
      http.get('dashboard/dashboardBreakout', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_BREAKOUT, r.data)
    return r.data
  },
  async getDashboardTop3({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardTop3', () =>
      http.get('dashboard/dashboardTop3', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_TOP3, r.data)
    return r.data
  },
  async getDashboardTop({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardTop3', () =>
      http.get('dashboard/dashboardTop', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_TOP, r.data)
    return r.data
  },
  async getDashboardProfit({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardProfit', () =>
      http.get('dashboard/dashboardProfit', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_PROFIT, r.data)
    return r.data
  },
  async getDashboardCycleTimes({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardCycleTimes', () =>
      http.get('dashboard/dashboardCycleTimes', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_CYCLETIMES, r.data)
    return r.data
  },
  async getDashboardTrend({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDashboardTrend', () =>
      http.get('dashboard/dashboardTrend', {
        params: options
      })
    )
    commit(types.SET_DASHBOARD_TREND, r.data)
    return r.data
  },
  async getInvoices({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getInvoices', () =>
      http.get('data/invoicesExport', {
        params: data
      })
    )
    return r.data
  },
  async getTechnicianPayroll({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getTechnicianPayroll', () =>
      http.get('dashboard/technicianPayroll', {
        params: data
      })
    )
    commit(types.SET_PAYROLL, r.data)
    return r.data
  },
  async saveTechData({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTechData', () =>
      http.post('user/saveTechData', data)
    )
    // commit(types.SET_TECHDATA, r.data)
    return r.data
  },
  async getDashboardPayments({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getDashboardPayments', () =>
      http.get('dashboard/dashboardPayments', {
        params: data
      })
    )
    commit(types.SET_PAYMENTS, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/actions.js